import graphql from "babel-plugin-relay/macro";

const GetTryAnotherBookingReasonsQuery = graphql`
  query GetTryAnotherBookingReasonsQuery {
    getTryAnotherBookingReasons
  }
`;

export default GetTryAnotherBookingReasonsQuery;
